import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { IoTimeSharp } from "react-icons/io5";
import { FaUserAlt } from "react-icons/fa";
import { IoIosTime } from "react-icons/io";
import axios from 'axios'; // Import axios
import './layout.css';

const EmpLayout = ({ children }) => {
    const location = useLocation();
    const { userId } = useParams(); // Fetch userId from URL params
    const [user, setUser] = useState(null);
    const [ setError] = useState(null);

    useEffect(() => {
        const fetchUser = async () => {
            try {
                const response = await axios.get(`http://localhost:5544/api/user/user/${userId}`);
                setUser(response.data);
            } catch (error) {
                setError('Error fetching user data');
                console.error('Error fetching user:', error);
            }
        };

        if (userId) {
            fetchUser();
        }
    }, [userId]);

    return (
        <div className='container-fluid'>
            <h1 className='layouts-subtitle'><IoIosTime /> {user ? ` ${user.name} Schedule!` : 'Welcome, Guest!'}</h1>
            <hr/>
            <h1 className='layouts-subtitle'><FaUserAlt /> {user ? ` ${user.name}!` : 'Welcome, Guest!'}</h1>
            <hr/>
            <div style={{ marginTop: '10px' }}>
                <section>
                    <div className="nav-container">
                        <ul className="nav-list">
                            <li className="nav-item">
                                <NavLink
                                    id="emps-timing-link"
                                    className={({ isActive }) => `nav-link ${isActive || location.pathname.startsWith('/leave-report') ? 'active' : ''}`}
                                    to="/emp-timing"
                                >
                                    <IoTimeSharp /> Timing and Shift
                                </NavLink>
                            </li>
                        </ul>
                    </div>
                    <div className="content">
                        {children}
                    </div>
                </section>
            </div>
        </div>
    );
};

export default EmpLayout;
